import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import { createExperienceChildConfigsQueryKey } from '@/utils/queryKeys';
import type {
  GetExperienceChildConfigsQuery,
  GetExperienceChildConfigsQueryVariables,
} from './useGetExperienceChildConfigs.generated';

const document = gql`
  query GetExperienceChildConfigs {
    getExperienceChildConfigs {
      name
      title
      kind
      category
      layoutId
    }
  }
`;

export const useGetExperienceChildConfigs = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { data, isLoading } = useQuery<
    GetExperienceChildConfigsQuery,
    Error,
    GetExperienceChildConfigsQuery,
    ReturnType<typeof createExperienceChildConfigsQueryKey>
  >({
    queryKey: createExperienceChildConfigsQueryKey(),
    queryFn: () =>
      gqlClient.request<
        GetExperienceChildConfigsQuery,
        GetExperienceChildConfigsQueryVariables
      >(document),
    enabled,
    // The catalog of creatable child configs is a static, argument-less server
    // list, so it never goes stale within a session — fetch it once.
    staleTime: Infinity,
  });

  return {
    configs: data?.getExperienceChildConfigs ?? [],
    isLoading,
  };
};
